import React, { useState } from 'react';
import { IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { DriveFileRenameOutline } from '@mui/icons-material';

const EditDecan = ({ data, saveData }) => {
    const [open, setOpen] = useState(false);
    const [newName, setNewName] = useState('');

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        saveData(newName);
        handleClose();
    };

    const handleChange = (event) => {
        setNewName(event.target.value);
    };

    return (
        <>
            <IconButton onClick={handleOpen}>
                <DriveFileRenameOutline />
            </IconButton>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Edit Action</DialogTitle>
                <DialogContent>
                    {/* Add a description of what to enter */}
                    <Typography
                        variant="body1"
                        style={{ marginBottom: '1rem' }}
                    
                    >Change the name to be more descriptive of the action. e.g. instead of pruning put "Pinching".</Typography>

                    <TextField
                        label="New Name"
                        value={newName}
                        onChange={handleChange}
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSave} variant="contained" color="primary">Save</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default EditDecan;